
import { Injectable } from '@angular/core';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private oidcSecurityService: OidcSecurityService) { }

    initAuth() {
        return new Promise<{ loginResponse: LoginResponse, idTokenData: any }>((resolve, reject) => {
            this.oidcSecurityService.checkAuth().subscribe(lr => {
                if (!lr.isAuthenticated) {
                    console.log('Performing login');

                    this.oidcSecurityService.authorize(undefined, {
                        customParams: {
                        }
                    });
                }
                this.oidcSecurityService.getPayloadFromIdToken().subscribe(idt => {
                    resolve({
                        loginResponse: lr,
                        idTokenData: idt
                    });
                });
            });
        })
    }

    getUser(): Observable<LoginResponse> {
        return this.oidcSecurityService.checkAuth();
    }
    
    getRoles(): Promise<string[]>{
        return new Promise<string[]>((resolve,reject)=>{
            this.oidcSecurityService.checkAuth().subscribe(lr => {
                if(!lr.isAuthenticated){
                    reject('Not authenticated');
                    return;
                }

                resolve(lr.userData.roles);

            });


        })
    }


    logout() {
        this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
            localStorage.clear();
            sessionStorage.clear();
        });
    }
}